import { Component, Input } from '@angular/core';

import { Usuario } from '../../usuario';

@Component({
    selector: 'sgt-usuario-permissao-meta',
    templateUrl: './usuario-permissao-meta.component.html',
    styleUrls: ['./usuario-permissao-meta.component.less']
})
export class UsuarioPermissaoMetaComponent {
    @Input() entity: Usuario;
}
